package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Cursor.INHERIT
import com.downdogapp.Cursor.POINTER
import com.downdogapp.Display.FLEX
import com.downdogapp.JustifyContent.CENTER
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.AbstractView
import com.downdogapp.client.singleton.App
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLSpanElement

class TogglePill(private val lazyLeftText: () -> String,
                 private val lazyRightText: () -> String,
                 private val getValue: () -> Boolean,
                 onValueChanged: (right: Boolean) -> Unit) : AbstractView() {

  private var leftView: HTMLDivElement
  private var rightView: HTMLDivElement
  private var leftLabel: HTMLSpanElement
  private var rightLabel: HTMLSpanElement

  override val root = createDiv {
    display = FLEX
    borderRadius = px(50) // effectively max value
    border = Border.solid(px(2), Color.WHITE)

    leftView = horizontalFlexBox(horizontalJustify = CENTER) {
      borderTopLeftRadius = px(50)
      borderBottomLeftRadius = px(50)

      leftLabel = label(null, 14, FontWeight.MEDIUM) {
        marginVertical = px(5)
        marginHorizontal = px(15)
      }
      onClick {
        onValueChanged(false)
        refresh()
      }
    }

    rightView = horizontalFlexBox(horizontalJustify = CENTER) {
      borderTopRightRadius = px(50)
      borderBottomRightRadius = px(50)

      rightLabel = label(null, 14, FontWeight.MEDIUM) {
        marginVertical = px(5)
        marginHorizontal = px(15)
      }
      onClick {
        onValueChanged(true)
        refresh()
      }
    }
  }

  init {
    refresh()

    // We can only set the buttons to equal width after the DOM loads
    // so update the minWidth every 100 milliseconds
    for (i in 0..5) {
      App.runAfter(seconds(0.1 * i)) {
        updateWidths()
      }
    }
  }

  fun refresh() {
    val rightActive = getValue()

    leftLabel.text = lazyLeftText()
    rightLabel.text = lazyRightText()

    leftLabel.txtColor = if (rightActive) Color.WHITE else Color.BLACK
    rightLabel.txtColor = if (rightActive) Color.BLACK else Color.WHITE

    leftView.bgColor = if (rightActive) Color.CLEAR else Color.WHITE
    rightView.bgColor = if (rightActive) Color.WHITE else Color.CLEAR

    leftView.cursor = if (rightActive) POINTER else INHERIT
    rightView.cursor = if (rightActive) INHERIT else POINTER

    updateWidths()
  }

  private fun updateWidths() {
    leftView.minWidth = px(rightView.offsetWidth)
    rightView.minWidth = px(leftView.offsetWidth)
  }
}

fun HTMLElement.togglePill(lazyLeftText: () -> String,
                           lazyRightText: () -> String,
                           getValue: () -> Boolean,
                           onValueChanged: (right: Boolean) -> Unit,
                           init: HTMLDivElement.() -> Unit = {}): TogglePill {
  val view = TogglePill(lazyLeftText, lazyRightText, getValue, onValueChanged)
  append(view.root)
  view.root.apply(init)
  return view
}
